import { ProfileCitizenshipView } from "./profile-citizenship-view";
import { useQuery } from "@apollo/client";
import { ApplicantProfileCitizenshipViewContainerApplicantUserDocument } from "../../../../generated";
import { ComponentQueryLoader } from "../../../shared/component-query-loader";
import { lookupCountryQuery } from "./profile-citizenship-country-query";
import { useNavigate } from "react-router-dom";
import { getItem } from "../../../shared/local-storage";

export const ProfileCitizenshipViewContainer = () => {
  const navigate = useNavigate();
  const applicantUserId = getItem('applicantUserId');

  const {
    data: countryCitizenshipData,
    loading: countryCitizenshipDataLoading,
    error: countryCitizenshipError,
  } = useQuery(ApplicantProfileCitizenshipViewContainerApplicantUserDocument, {
    variables: {
      applicantUserId,
    },
  });

  const {
    data: countryData,
    loading: countryLoading,
    error: countryError,
  } = useQuery(lookupCountryQuery);

  const handleEditToggle = () => {
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/\/[^/]+$/, "/edit");
    navigate(newPath);
  };

  return (
    <ComponentQueryLoader
      hasData={
        countryData?.countries &&
        countryCitizenshipData?.applicantUser?.personalInformation?.citizenship
      }
      loading={countryCitizenshipDataLoading || countryLoading}
      error={countryCitizenshipError || countryError}
      hasDataComponent={
        <ProfileCitizenshipView
          citizenship={
            countryCitizenshipData?.applicantUser?.personalInformation
              ?.citizenship
          }
          countries={countryData?.countries?.eventPayload?.countries}
          onEditToggle={handleEditToggle}
        />
      }
    />
  );
};
